import * as yup from 'yup';

import i18n from '@src/app/i18n/config';

import {
  Gender,
  PersonalDocumentMaxLength,
  allowOnlyNumbers,
} from '@shared/index';

export const personalDocumentsSchema = yup
  .object()
  .shape({
    passportSeriesAndNumber: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .test(
        'length',
        i18n.t('COMMON:errors.required'),
        (val) =>
          allowOnlyNumbers(val)?.length ===
          PersonalDocumentMaxLength.PASSPORTSERIES
      ),
    codeDepartment: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .test(
        'length',
        i18n.t('COMMON:errors.required'),
        (val) =>
          allowOnlyNumbers(val)?.length ===
          PersonalDocumentMaxLength.DEPARTMENT_CODE
      ),
    nameDepartment: yup.string().required(i18n.t('COMMON:errors.required')),
    dateIssue: yup.string().required(i18n.t('COMMON:errors.required')),
    snils: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .test(
        'length',
        i18n.t('COMMON:errors.required'),
        (val) =>
          allowOnlyNumbers(val)?.length === PersonalDocumentMaxLength.SNILS
      ),
    inn: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .test(
        'length',
        i18n.t('COMMON:errors.required'),
        (val) => allowOnlyNumbers(val)?.length === PersonalDocumentMaxLength.INN
      ),
    gender: yup
      .mixed<Gender>()
      .oneOf(Object.values(Gender))
      .required(i18n.t('COMMON:errors.required')),
  })
  .required();
